import { sortByKey } from "@notemeal/utils/sort";
import { MenuBuilderType } from "./MenuBuilderMealSchema";
import { UseFormReturn } from "react-hook-form";

export const getUniqueDiningStationNames = (form: UseFormReturn<MenuBuilderType>) => {
  const diningStationNames = sortByKey(
    form
      .getValues("weeks")
      .flatMap(week => week.meals)
      .flatMap(meal => meal.rows)
      // only autocomplete dining stations that are not associated with a template
      .filter(row => row.diningStationName.length > 0 && row.includeInAutoComplete),
    "diningStationName"
  ).map(row => row.diningStationName);
  return Array.from(new Set(diningStationNames));
};
